import { put } from 'redux-saga/effects';
import { saveAddressFields } from './addressModule';
import { getAddressHash, replaceAddressWithHash } from './addressUtils';

export function* replaceAddressWithHashSaga(obj, key) {
    const addressObj = key ? obj[key] : obj;
    const addressHash = getAddressHash(addressObj);
    yield put(saveAddressFields(addressObj));
    return replaceAddressWithHash(obj, addressHash, key);
}
